import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminAddBuyersToListMutation,
  AdminAddBuyersToListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminAddBuyersToListMutation = graphql(`
  mutation adminAddBuyersToList($input: AddBuyersToListInput!) {
    adminAddBuyersToList(input: $input) {
      id
      name
    }
  }
`);

type AddEntriesParams = { buyerListGuid: string; buyerGuids: string[] };

export function useAdminAddBuyerEntries(
  options?: UseMutationOptions<
    AdminAddBuyersToListMutation,
    unknown,
    AdminAddBuyersToListMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminAddBuyersToListMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      options?.onSuccess?.(data, variables, context);
    },
  });
  return {
    ...rest,
    mutate: ({ buyerListGuid, buyerGuids }: AddEntriesParams) =>
      innerMutate({ input: { id: buyerListGuid, buyerIds: buyerGuids } }),
  };
}
